export default __webpack_public_path__ + "static/media/pantry2-after1-1024w.75674b87.png";